import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { DesBanner, MultiBanner } from './banners';
import { useUpmarketBannerVisibility } from './hooks/usePjmBannerVisibility';

export const UpmarketBanners = () => {
    const { experience } = getContext();
    const { withDesBanner, withMultiBanner } = useUpmarketBannerVisibility();

    if (experience.isBusiness) {
        return null;
    }

    if (withDesBanner) {
        return <DesBanner />;
    }

    if (withMultiBanner) {
        return <MultiBanner />;
    }

    return null;
};
